import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Save, CheckCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminSettings = () => {
  const { getAuthHeader } = useAuth();
  const [settings, setSettings] = useState({
    contactPhone: '07527006966',
    contactEmail: 'milliesmotorhomehire@gmail.com',
    whatsappNumber: '07527006966',
    facebookPageUrl: 'https://www.facebook.com/milliesmotorhomehire',
    address: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/admin/settings`, getAuthHeader());
      if (response.data) {
        setSettings(response.data);
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${API_URL}/api/admin/settings`, settings, getAuthHeader());
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (error) {
      console.error('Error saving settings:', error);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center p-8"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div></div>;
  }

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-slate-900">Settings</h1>
        <p className="text-slate-600">Manage your website settings</p>
      </div>

      <div className="max-w-2xl">
        <Card>
          <CardHeader>
            <CardTitle>Contact Information</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label>Contact Phone</Label>
                <Input 
                  value={settings.contactPhone} 
                  onChange={(e) => setSettings({...settings, contactPhone: e.target.value})} 
                  placeholder="07527006966"
                />
              </div>
              <div>
                <Label>Contact Email</Label>
                <Input 
                  type="email"
                  value={settings.contactEmail} 
                  onChange={(e) => setSettings({...settings, contactEmail: e.target.value})} 
                  placeholder="milliesmotorhomehire@gmail.com"
                />
              </div>
              <div>
                <Label>WhatsApp Number</Label>
                <Input 
                  value={settings.whatsappNumber} 
                  onChange={(e) => setSettings({...settings, whatsappNumber: e.target.value})} 
                  placeholder="07527006966"
                />
              </div>
              <div>
                <Label>Facebook Page URL</Label>
                <Input 
                  value={settings.facebookPageUrl} 
                  onChange={(e) => setSettings({...settings, facebookPageUrl: e.target.value})} 
                  placeholder="https://www.facebook.com/milliesmotorhomehire"
                />
              </div>
              <div>
                <Label>Address (optional)</Label>
                <Input 
                  value={settings.address || ''} 
                  onChange={(e) => setSettings({...settings, address: e.target.value})} 
                  placeholder="Enter your business address"
                />
              </div>

              <div className="pt-4">
                <Button type="submit" disabled={saving}>
                  {saving ? (
                    <>Saving...</>
                  ) : saved ? (
                    <><CheckCircle className="h-4 w-4 mr-2" /> Saved!</>
                  ) : (
                    <><Save className="h-4 w-4 mr-2" /> Save Settings</>
                  )}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>

        <Card className="mt-6">
          <CardHeader>
            <CardTitle>Admin Account</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-slate-600 text-sm">
              To change your admin password, please contact your developer.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AdminSettings;
